import React, { useState } from 'react';

import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Close
} from "@mui/icons-material";

import { ModelBase } from "@models";
import { 
  Character,
  CharacterFeatureSource,
  CharacterGift,
  Gift,
} from "@dndModels";
import { CHARACTER_LEVELS } from "@dndModels/Constants";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";

import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";
// import ButtonBox from '../../../../../components/input/buttons/ButtonBox';
import CharacterFeatureSourcesOuter from "@dndComponents/character/features/CharacterFeatureSourcesOuter";
import AddButton from "@components/input/buttons/AddButton";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  character: Character;
  onChange: (changed: Character, do_main: boolean) => void;
}

const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterGiftInput({
  character,
  onChange
}: Props) {
  // const [fetched, setFetched] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [reloading, setReloading] = useState(false);
  const [new_gift, setNewGift] = useState(false);
  const [filter, setFilter] = useState<any>({ });
  const [expanded_gift_id, setExpandedGiftID] = useState(character.gifts.length === 1 ? character.gifts[0].true_id : "");
  // const [swapping, setSwapping] = useState<Gift | null>(null);
  const [change_time, setChangeTime] = useState(0);
  const updateFilter = (changed: any = {}) => {
    setFilter({...changed});
  }

  const renderAddAnotherGift = () => {
    return (
      <div style={{ float: "right" }}>
        <AddButton
          label="Add Another Gift"
          onClick={() => {
            setNewGift(true);
          }} 
        />
      </div>
    );
  }

  if (character.gifts.length === 0 || new_gift) {
    return (
      <Grid container spacing={0} direction="row">
        { new_gift && 
          <Grid size={12}>
            <Button variant="contained" color="primary"
              onClick={() => {
                setNewGift(false);
              }}>
              Cancel Add
            </Button>
          </Grid>
        }
        <Grid size={12}>
          <SelectObjectIndex
            data_type="gift"
            character={character}
            blocked_ids={character.character_options.blocked}
            filter={filter}
            updateFilter={updateFilter}
            quick_fields={["gift_type"]}
            onClick={(obj: ModelBase) => {
              if (obj instanceof Gift) {
                connect_util.addGift(character, obj).then(char_gift => {
                  onChange(character, false);
                  setNewGift(false);
                  setExpandedGiftID(char_gift.true_id);
                });
              }
            }}
            disableObj={(obj: ModelBase) => {
              let disabled = false;
              let reasons = "";
              if (obj instanceof Gift) {
                if (character.gifts.filter(o => 
                  o.source_id === obj._id || 
                  o.variant_ids.includes(obj._id)).length > 0) {
                  disabled = true;
                  reasons = "You already have this gift";
                }
              }
              return { disabled, reasons };
            }}
          />
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          { renderAddAnotherGift() }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterFeatureSourcesOuter
            char={character}
            sources={character.gifts}
            change_time={change_time}
            expanded_cfs_id={expanded_gift_id}
            extra_cfs_header_control={(cfs: CharacterFeatureSource) => {
              if (cfs instanceof CharacterGift) {
                const char_gift = cfs;
                return (
                  <Grid container spacing={0} direction="row">
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      { char_gift.source && char_gift.source.max_level > 1 &&
                        <SelectStringBox 
                          name="Level"
                          options={CHARACTER_LEVELS}
                          value={`${char_gift.level}`}
                          onChange={(value: string) => {
                            const level: number = +value;
                            char_util.changeSourceLevel(character, char_gift.source_id, level);
                            char_util.repopulateCharFeatureBases(character).then(() => {
                              onChange(character, false);
                              setChangeTime(common_util.get_time_number());
                            });
                          }}
                        />
                      }
                    </Grid>
                    <Grid
                      size={{
                        xs: 3
                      }}>
                      <Close style={{ cursor: "pointer" }}
                        onClick={() => {
                          connect_util.removeGift(character, char_gift);
                          onChange(character, false);
                          setNewGift(false);
                          setExpandedGiftID("");
                        }} 
                      />
                    </Grid>
                  </Grid>
                );
              }
              return undefined;
            }}
            // extra_cfs_controls={(cfs: CharacterFeatureSource) => {
            //   if (cfs instanceof CharacterGift) {
            //     const char_gift = cfs;
            //     const valid_variants = char_gift.source ? char_gift.source.variant_group.filter(o => common_util.any_overlaps(o.source_book_ids, character.character_options.source_books) && !character.character_options.blocked.includes(o._id)) : [];
            //     if (char_gift.source && valid_variants.length > 1) {
            //       return [
            //         <Grid item xs={12} key="change_variant">
            //           <ButtonBox 
            //             name="Change Variant"
            //             onClick={() => {
            //               setSwapping(char_gift.source);
            //             }}
            //           />
            //         </Grid>
            //       ];
            //     }
            //   }
            //   return [];
            // }}
            // extra_bottom_controls={() => {
            //   // debugger;
            //   return [];
            // }}
            // cfs_sort={(a: CharacterFeatureSource, b: CharacterFeatureSource) => {
            //   if (a instanceof CharacterGift && b instanceof CharacterGift) {
            //     return a.position > b.position ? 1 : -1;
            //   }
            //   return 1;
            // }}
            // onChange={() => {
            //   onChange(character, false);
            // }}
            onCFSSelect={(cfs: CharacterFeatureSource | undefined) => {
              setExpandedGiftID(cfs ? cfs.true_id : "");
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      </Grid>
    );
  }
}
